<template>
  <div>
    <div class="grid-content maintitle">
      <span>{{ $t("message.标签分组编辑") }}</span>
    </div>

    <div class="topContainer">
      <div class="grid-content content-margin topFix">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button size="medium" round @click.native="goBack">
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="!isEditMode && !isInit">
            <el-button size="medium" round @click="isEditMode = true">
              <i class="iconfont">&#xe618;</i>
              {{ $t("message.修改") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="isEditMode">
            <el-button size="medium" round @click="doSave" type="primary">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.保存") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="!isInit">
            <el-button size="medium" round @click.native="refresh">
              <i class="iconfont">&#xe667;</i>
              {{ $t("message.刷新") }}
            </el-button>
          </el-link>
        </div>
      </div>
    </div>

    <div class="grid-content subtitle">
      <span>{{ $t("message.标签分组") }}</span>
    </div>
    <div class="grid-content content-margin">
      <el-divider></el-divider>
      <table class="simpleRow">
        <tr v-if="interestedTagGroup.id > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.标签分组ID") }}</span>
          </td>
          <td>
            <el-input
              :disabled="true"
              v-model="interestedTagGroup.id"
              readonly
              size="mini"
              placeholder=""
              style="width: 175px"
            >
            </el-input>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.标签分组名称") }}</span>
          </td>
          <td>
            <el-input
              :disabled="!isEditMode"
              size="mini"
              class="linkTextArea"
              v-model="interestedTagGroup.groupname"
              type="textarea"
              :placeholder="$t('message.请输入产品名称')"
              maxlength="50"
              show-word-limit
            >
            </el-input>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.排序") }}</span>
          </td>
          <td>
            <el-input-number v-model="interestedTagGroup.sort" :min="0" :max="10" label="描述文字" size="mini"></el-input-number>
          </td>
        </tr>

        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.状态") }}</span>
          </td>
          <td>
            <el-radio-group :disabled="!isEditMode" v-model="interestedTagGroup.state">
              <el-radio :label="0">{{ $t("message.正常") }}</el-radio>
              <el-radio :label="1">{{ $t("message.禁用") }}</el-radio>
            </el-radio-group>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
import { topfixfunc } from "@/utils/topFix";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";

export default {
  name: "pointGroupDetail",
  components: {
  },
  data() {
    return {
      tableHeight: 500,

      interestedTagGroup: {
        appid: 188,
        id: 0,
        state: 0,
        sort:0,
        groupname: "",
        createdate: "",
        createid: "",
        editdate: "",
        editid: "",
      },

      createName: "",
      editName: "",

      isEditMode: true,
      isInit: true,
      showResourceStore: false,
    };
  },
  mounted: function () {
    // 用来监听el-main滚动事件
    topfixfunc();
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    goBack() {
      this.$router.go(-1); //返回上一层
    },

    doSave() {
      if (this.interestedTagGroup.groupname == "") {
        this.$message({
          type: "error",
          message: this.$t("message.名称不能为空"),
        });
        return;
      }
      this.isEditMode = false;

      if (this.isInit)
        rejecthttp(
          true,
          "post",
          "/manage/interestedtag/creategroup",
          this.interestedTagGroup,
          this,
          (doc) => {
            changeflagCLOSED(doc, 1, this);
            if (doc.data.Code == "MSGKEY_OK") {
            }
          }
        );
      else {
        this.interestedTagGroup.editdate = null;
        this.interestedTagGroup.editid = null;
        this.interestedTagGroup.createdate = null;
        this.interestedTagGroup.createid = null;
        rejecthttp(
          true,
          "post",
          "/manage/interestedtag/editgroup",
          this.interestedTagGroup,
          this,
          (doc) => {
            changeflagCLOSED(doc, 1, this);
            if (doc.data.Code == "MSGKEY_OK") {
            }
          }
        );
      }
    },

    refresh() {
      if (!this.interestedTagGroup.id) {
        return;
      }
      this.$http
        .get("/manage/interestedtag/groupdetail", {
          params: {
            appid: this.interestedTagGroup.appid,
            groupid: this.interestedTagGroup.id,
          },
        })
        .then((doc) => {
          if (doc.data.Code != "MSGKEY_OK") {
            this.$message({
              type: "error",
              message: doc.data.Message,
            });
          } else {
            console.log("interested group detail:", doc.data);
            this.interestedTagGroup = doc.data.data;
            // this.createName = doc.data.exData.datas[0].name;
            // this.editName = doc.data.exData.datas[1].name;
            this.interestedTagGroup.createdate = commonUtil.formatDate(
              this.interestedTagGroup.createdate
            );
            this.interestedTagGroup.editdate = commonUtil.formatDate(
              this.interestedTagGroup.editdate
            );
          }
        });
    },

    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
  },

  created() {
    this.interestedTagGroup.appid = this.$route.query.appid
      ? this.$route.query.appid
      : 0;
    if (this.$route.query.id) {
      this.interestedTagGroup.id = this.$route.query.id;
      this.isEditMode = this.$route.query.isEditMode ? true : false;
      this.isInit = false;
    }
    this.refresh();
  },

  computed: {},
  // // 隐藏固定栏
  // destroyed () {
  //   var topFix=document.querySelector('.topFix')
  //   // 固定栏隐藏
  //   topFix.style.display='none'
  // }
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/interestedTag/interestedTagGroupDetail.vue